var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageCode)?_c('div',{staticClass:"home"},[_c('commonHeader',{attrs:{"swiperList":_vm.indexList},on:{"changePageCode":_vm.onChange}}),_vm._v(" "),(_vm.pageCode !== '06' && _vm.pageCode !== '07' && _vm.pageCode !== '08')?_c('EntiretyHome'):_c('OperateHome')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6145d6f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = null
// module chunks = 